<div class="left-modal full dark">
  <div class="close"  (click)="close()"></div>
  <div class="full-image" (swipeleft)="previous()" (swiperight)="next()">
    @if (clips.length > 1) {
      <div class="slider-arrow next" (click)="next()"></div>
      <div class="slider-arrow previous" (click)="previous()"></div>
    }
    <div class="imageConteiner">
      @if (clips[position]?.clip_url) {
        <div class="watermark">
          {{ getUserLong() }}
        </div>
      }
      @if (clips[position]?.clip_url) {
        <video width="100%" height="100%" [attr.src]="clips[position]?.clip_url" autoplay controls></video>
      }
      <!-- <video *ngIf="clips[position].clip_url" width="100%" height="100%" src="/../assets/img/{{clips[position].clip_url}}" autoplay></video> -->
      @if (!clips[position] || !clips[position]?.clip_url) {
        <img src="/../assets/img/no_video.png" alt="">
      }
      <ng-container>
        <div class="cont_detail" [ngClass]="{'close-detail': !toggleDetail || !clips[position]}">
          @if (toggleDetail && clips[position]) {
            <p title="{{clips[position].clip_name}}">{{clips[position].clip_name}}</p>
            @if (clips[position].date) {
              <span>{{'Unit' | translate}} {{clips[position].unit_number}}, {{clips[position].date | date: 'MMM/dd/yyyy'}}</span>
            }
            <span class="sub-titles-slider">{{"Director's notes" | translate}}: {{clips[position].directorsNotes || '--'}}</span>
            <span class="sub-titles-slider">{{'Description' | translate}}: {{clips[position].descriptions || '--'}}</span>
            @if (clips[position].selected_clip) {
              <a class="show-selected"></a>
            }
          }
          <span class="toggle-section" (click)="changeToggleDetail()">
            <i>|||</i>
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
